import React from 'react';

export function CapacityInput({ valuePb, nodeCount, useableCapacityPB, onChange, step = "0.1", min = "0" }) {
  return (
    <>
      <input
        type="number"
        step={step}
        min={min}
        value={valuePb}
        onChange={onChange}
        className="input-box"
        placeholder="Enter minimum RAW capacity"
      />
      <p className="text-xs text-gray-400 mt-1">{nodeCount} Storage Servers | {useableCapacityPB} PB Useable Capacity</p>
    </>
  );
}

export function NodeCountInput({ nodeCount, minNodes, computedCapacityTB, useableCapacityPB, onChange }) {
  return (
    <>
      <input
        type="number"
        step="1"
        min={minNodes}
        value={nodeCount}
        onChange={onChange}
        className="input-box"
        placeholder="Enter node count"
      />
      <p className="text-xs text-gray-400 mt-1">{useableCapacityPB} PB Useable Capacity</p>
    </>
  );
}
